module.exports = __webpack_public_path__ + "images/banners/smama_banner_2224c865ef5e118ccf262f5fa0d4f6f2.jpg";